SupportBasePresentation = require('./base')
SupportPresenterUtilPresentation = require('./presenter_util')
SupportGetawaysMarketRateStatusAndNotesPresentation = require('./getaways_market_rate_messages')

class SupportGetawaysMarketRatePresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportGetawaysMarketRateStatusAndNotesPresentation

	getLookupKeySequence: () ->
		keys = []

		if @order?
			keys.push(SupportPresenterUtilPresentation::getStatusKey(@order))
		SupportPresenterUtilPresentation::concatenateLookupKeys(keys)

module.exports = SupportGetawaysMarketRatePresenterPresentation
